import React from "react";
//#region redux
//#endregion
//#region types
import { TextInputProps, ToggleProps } from "models/propTypes/wintFormPropsTypes";
import { TranslationKeys } from "translations";
import { CustomerConstants, IconDefinitionConstants } from "utils/constants";
import { CustomerOtherDetailsSectionProps } from "models/propTypes/customerPropTypes";
//#endregion
//#region components
import GlnInput, { CustomerGlnInputProps } from "./glnInput";
import { HorizontalFormField, GroupSection, TextInput, Toggle } from "components/common/wintForms";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const CustomerOtherDetailsSection: React.FC<CustomerOtherDetailsSectionProps> = ({ connect }) => {
  return (
    <GroupSection
      header={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.OtherDetails)}
      icon={IconDefinitionConstants.WSettings}
      navKey={CustomerConstants.SettingsNavKeys.Other}
    >
      <HorizontalFormField<CustomerGlnInputProps>
        Component={GlnInput}
        organizationNumber={connect("generalInfo.orgNumber").value}
        {...connect("otherDetailsSettings.glnNumber")}
        label={TranslationKeys.Invoice.GLNNumber}
        descriptionText={TranslationKeys.Customer.GlnHelp}
        optional
      />
      <HorizontalFormField<TextInputProps>
        Component={TextInput}
        {...connect("otherDetailsSettings.vatNumber")}
        label={TranslationKeys.Invoice.VATNumber}
        descriptionText={TranslationKeys.Invoice.VATNumberHelpText}
        optional
      />
      <HorizontalFormField<ToggleProps>
        Component={Toggle}
        {...connect("otherDetailsSettings.includeVATNumber")}
        label={TranslationKeys.Invoice.IncludeVATNumberInInvoice}
        descriptionText={TranslationKeys.Invoice.IncludeVATNumberInInvoiceHelpText}
      />
    </GroupSection>
  );
};

export default CustomerOtherDetailsSection;
